import { OnInit, ElementRef, AfterViewInit, EventEmitter } from '@angular/core';
import { Component, Input, Output, ChangeDetectorRef } from '@angular/core';

@Component({
	selector: 'app-dialog-toast',
	templateUrl: './dialog-toast.component.html',
	styleUrls: ['./dialog-toast.component.scss']
})
export class DialogToastComponent implements OnInit, AfterViewInit {
	@Input() message: string;
	@Input() durationMilliSeconds: number = 4000;
	@Input() state: 'default' | 'success' | 'warning' | 'error' = 'default';
	@Input() showConfirmButton: boolean = false;

	@Output() dismiss = new EventEmitter<boolean>();

	constructor(public cdRef: ChangeDetectorRef, private elRef: ElementRef) {}

	ngOnInit() {
		this.durationMilliSeconds =
			this.state === 'error' ? null : this.durationMilliSeconds;

		if (this.durationMilliSeconds) {
			setTimeout(() => {
				this.dismiss.emit(false);
			}, this.durationMilliSeconds);
		}
	}

	ngAfterViewInit() {
		if (this.durationMilliSeconds) {
			const el: HTMLElement = this.elRef.nativeElement;
			el.style.setProperty(
				'--animation-duration',
				`${this.durationMilliSeconds}ms`
			);
		}
	}
}
